import { AbstractControl, ValidationErrors } from '@angular/forms';

export interface ContactoObligatorioParams {
  /** El tipo de cita efectivo es Campo o Campo Complementario (el panel de contacto existe). */
  esTipoCampo: boolean;
}

/**
 * Regla única de obligatoriedad de Nombre y Correo del contacto. La usan el asterisco,
 * los validadores del formulario y `validarFormulario`, para que no se desalineen.
 *
 * Es obligatorio en todo tipo Campo, complementario incluido.
 *
 * Desviación aprobada del legacy (requerimiento de QA): en el legacy
 * (CreateOrUpdateCumplimientoViewImpl.showInfoCamposDeCampo() →
 * `setRequired(visible && !isCumpComplementarios)`) el contacto era opcional en Campo
 * Complementario; ahora es obligatorio también ahí. Informe (18) e Informe Complementario (43)
 * no tienen panel de contacto.
 */
export function esContactoObligatorio(p: ContactoObligatorioParams): boolean {
  return p.esTipoCampo;
}

/** `Validators.required` que además rechaza valores formados solo por espacios. */
export function requiredTrimmed(control: AbstractControl): ValidationErrors | null {
  const valor = control.value;
  return valor === null || valor === undefined || String(valor).trim() === ''
    ? { required: true }
    : null;
}
